import { Page } from '@/layouts'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { Link } from 'react-router-dom'

export const PermissionDenied = () => {
  return (
    <Page>
      <div className="content">
        You are not authorized to access this page. Please contact the event host
        for further assistance.
        <div className="margin-top-10">
          <Space>
            <Link to={'/dashboard'}>
              <ArrowLeftOutlined /> Go back to Dashboard
            </Link>
          </Space>
        </div>
      </div>
    </Page>
  )
}
